import React from "react";
import Doctor_Appointment from "../../containers/Doctor_Appointment/index";

export default function Registration() {
    return (
        <div>
            <Doctor_Appointment />
        </div>
    );
}
